<div *ngIf="status =='Submitted' || status =='Approved'; else studentform">
    <app-viewcandidateprofile></app-viewcandidateprofile>
</div>
<ng-template #studentform>
    <app-candidate-profile></app-candidate-profile>
</ng-template>